var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(';')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
}
export class Request extends Component {
    constructor() {
        super('Request', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Validation criterias
            $('.form-check-validation-criteria').on('change', (event, checkbox) => {
                const validationCriterias = checkbox.parents('.validation-criterias');
                let isValid = true;
                validationCriterias.find('.form-check-validation-criteria').each((checkbox) => {
                    if (!checkbox.get(0).checked)
                        isValid = false;
                });
                validationCriterias.find('.validation-criterias-target').val(isValid ? '1' : '0');
                if (isValid) {
                    $('.validation-criterias .text-danger').addClass('d-none');
                }
                else {
                    $('.validation-criterias .text-danger').removeClass('d-none');
                }
            });
            $('.form-select-supports input, .form-select-show input').on('change', this.updateSubmitButtonState);
            this.updateSubmitButtonState();
            // Field other
            $('.form-field-other').each((field) => {
                const checkbox = field.find('input[type="checkbox"]');
                const text = field.find('input[type="text"]');
                if (text.val() != '') {
                    checkbox.get(0).checked = true;
                }
                checkbox.on('change', (event, checkbox) => {
                    if (checkbox.get(0).checked)
                        text.get(0).focus();
                });
                text.on('input', (event, input) => {
                    if (input.val() != '') {
                        checkbox.get(0).checked = true;
                    }
                    else {
                        checkbox.get(0).checked = false;
                    }
                });
            });
            // Sumbit request
            $('#btn-submit-request').on('click', this.submitRequest);
            $('#btn-export-pdf').on('click', this.exportPDF);
            this.success();
        });
    }
    updateSubmitButtonState() {
        // Select support type submit button state
        if ($('.form-main').hasClass('form-select-supports')) {
            const selectedSSupportCount = $('.form-select-supports input[type="checkbox"]:checked').length;
            if (selectedSSupportCount) {
                $('.form-main button[type="submit"]').removeClass('disabled');
            }
            else {
                $('.form-main button[type="submit"]').addClass('disabled');
            }
        }
        // Select show submit button state
        if ($('.form-main').hasClass('form-select-show')) {
            const selectedShowsCount = $('.form-check-select-show:checked').length;
            const selectedValidationCriteriasCount = $('.form-check-validation-criteria:checked').length;
            if (selectedShowsCount > 0 && selectedValidationCriteriasCount === $('.form-check-validation-criteria').length) {
                $('.form-main button[type="submit"]').removeClass('disabled');
            }
            else {
                $('.form-main button[type="submit"]').addClass('disabled');
            }
        }
    }
    submitRequest(event, button) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            button.addClass('is-loading');
            /*let PDFtarget = $.parseHTML('<iframe>');
        
            await HanakoPDF.print($('.pdf-page'), {
              fontPath: '/wp-content/themes/hanako-wp/dist/assets/fonts',
              pageTop: 1.5,
              pageBottom: 28.2,
              fontScaleFactorFix: .99,
              pageNumberOptions: {
                format: '{page}/{pages}',
                x: 10.5,
                y: 28.6,
                align: 'center'
              },
            }, PDFtarget);*/
            let data = new FormData();
            data.append('hw-action', 'submit-request');
            data.append('zkp', $('#zkp').text());
            data.append('step', '5');
            data.append('anonymous-statistics-accepted', $('#input-anonymous-statistics-accepted').get(0).checked ? '1' : '0');
            //data.append('pdf', dataURItoBlob(PDFtarget.get(0).src));
            const response = yield fetch('./', {
                method: 'POST',
                body: data,
            });
            const responseTest = yield response.text();
            location.href = '/mon-espace/soutiens/';
        });
    }
    exportPDF(event, button) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            button.addClass('is-loading');
            /*await HanakoPDF.print($('.pdf-page'), {
              fontPath: '/wp-content/themes/hanako-wp/dist/assets/fonts',
              pageTop: 1.5,
              pageBottom: 28.2,
              fontScaleFactorFix: .99,
              pageNumberOptions: {
                format: '{page}/{pages}',
                x: 10.5,
                y: 28.6,
                align: 'center'
              },
            });*/
            button.removeClass('is-loading');
        });
    }
}
